// Theme configurations for Gen-X Photo Studio
export const themes = {
  caribbean: {
    id: 'caribbean',
    name: 'Caribbean Vibes',
    description: 'Tropical colors with beach vibes',
    colors: {
      primary: '#ff6b6b',
      secondary: '#00d4aa',
      accent: '#ffd700',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      cardBg: 'rgba(255, 255, 255, 0.05)',
      text: '#ffffff',
      textMuted: 'rgba(255, 255, 255, 0.6)',
    },
    heroGradient: 'linear-gradient(135deg, rgba(255,107,107,0.3) 0%, rgba(0,212,170,0.3) 50%, rgba(255,215,0,0.3) 100%)',
  },
  professional: {
    id: 'professional',
    name: 'Professional Classic',
    description: 'Clean and elegant business look',
    colors: {
      primary: '#3B82F6',
      secondary: '#10B981',
      accent: '#F59E0B',
      background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #334155 100%)',
      cardBg: 'rgba(255, 255, 255, 0.08)',
      text: '#F8FAFC',
      textMuted: 'rgba(248, 250, 252, 0.6)',
    },
    heroGradient: 'linear-gradient(135deg, rgba(59,130,246,0.3) 0%, rgba(16,185,129,0.3) 100%)',
  },
  elegant: {
    id: 'elegant',
    name: 'Elegant Gold',
    description: 'Luxurious gold and black theme',
    colors: {
      primary: '#D4AF37',
      secondary: '#C0C0C0',
      accent: '#FFD700',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #2d2d2d 100%)',
      cardBg: 'rgba(212, 175, 55, 0.1)',
      text: '#FFFFFF',
      textMuted: 'rgba(255, 255, 255, 0.7)',
    },
    heroGradient: 'linear-gradient(135deg, rgba(212,175,55,0.4) 0%, rgba(0,0,0,0.6) 100%)',
  }
};

export const defaultTheme = 'caribbean';
